/** Units still waiting to join the fortress. The current roster is complete. */
export interface LockedUnit {
  id: string;
  role: string;
  hint: string;
}

export const LOCKED_UNITS: LockedUnit[] = [];
